<template>
  <div class="quick-quotation-container">
    <div class="quick-quotation-content content">
      <div class="m-b-lg pt-5">
        <h4 v-html="title"></h4>
      </div>

      <Panel class="age-input-panel-container" title="กรอกข้อมูล">
        <div class="package-plan-search-container row">
          <div class="form-group col-xs-7 col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                อายุ
              </span>
              <input
                type="text"
                class="form-control input-sm"
                :class="{ 'bd-red': errors.has('age') }"
                v-model="age"
                :disabled="isDisabledForm"
              />
            </div>
          </div>
          <Button
            class="btn-dark btn-s-xs"
            type="info"
            @click.native="onSearchPackageInformation"
            :disabled="isDisabledForm"
          >
            <i class="fa fa-search"></i> ตรวจสอบราคา
          </Button>
        </div>
        <div class="input-group" v-if="errors.has('age')">
          <small class="m-l-lg m-t-lg text-danger h5 age-error-text">
            กรุณากรอกข้อมูลอายุตั้งแต่ 1 - 70 ปี
          </small>
        </div>
      </Panel>

      <div
        class="insurance-package-plan-information-section"
        v-show-slide="insurancePlanInformationData"
      >
        <InsuranceTablePlan2 :insurancePlan="insurancePlan" :insuredAge="age" />
        <div class="print-quotation-btn-container">
          <Button
            class="print-quotation-btn"
            type="primary"
            @click.native="generateQuotationDocument()"
          >
            ดูข้อมูลเช็กเบี้ยประกันภัย
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import { Validator } from 'vee-validate'
import _ from 'lodash'

import Button from '@/components/Button'
import Panel from '@/components/Panel'
import InsuranceTablePlan2 from '@/components/Table/InsuranceTablePlan2/InsuranceTablePlan2'
import { DOMAIN } from '@/lib/api'
import { packagePlanType } from '@/lib/global'
import { generatePdfViewerUrl } from '@/lib/services'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

const { mapFields: mapPlansFields } = createHelpers({
  getterType: 'getPlansFields',
  mutationType: 'updatePlansFields',
})

export default {
  name: 'QuickQuotation',
  data: () => ({
    typeInsurance: 'personal',
    isDisabledForm: false,
    age: null,
    rules: {
      age: 'required|numeric',
    },
    errors: null,
    title: "การขาย / <span class=\"text-success\">เช็คเบี้ยประกันภัย</span>"
  }),
  watch: {
    insurancePlanInformationData: {
      handler() {
        this.isDisabledForm = true
      },
      deep: true,
    },
    'insurancePlan.isCheckOPD'() {
      if (this.insurancePlan.isCheckOPD) {
        if (this.insurancePlan.opdType) {
          this.onTriggerPackagePlanChange()
        } else {
          this.insurancePlan.opdType = 'OPD(Standard)'
        }
      } else {
        this.insurancePlan.opdType = ''
      }
    },
    'insurancePlan.isCheckHIB'() {
      this.onTriggerPackagePlanChange()
    },
    'insurancePlan.isCheckCancer'() {
      this.onTriggerPackagePlanChange()
    },
    'insurancePlan.isCheckCI'() {
      this.onTriggerPackagePlanChange()
    },
    'insurancePlan.opdType'() {
      if (this.insurancePlan.opdType) {
        this.insurancePlan.isCheckOPD = true
      }

      this.onTriggerPackagePlanChange()
    },
    generatedQuickQuotationData(quickQuotationUrl) {
      if (quickQuotationUrl) {
        window.open(generatePdfViewerUrl(`${DOMAIN}${quickQuotationUrl}`), '_blank')
      }
    },
  },
  computed: {
    ...mapGetters(['insurancePlanInformationData', 'deductibleInformationData']),
    ...mapQuotationFields({
      insurancePlan: 'insurancePlan',
    }),
    ...mapPlansFields({
      generatedQuickQuotationData: 'generatedQuickQuotation.data',
    }),
  },
  components: {
    Button,
    Panel,
    InsuranceTablePlan2,
  },
  methods: {
    ...mapActions([
      'getInsurancePlanInformation',
      'getInsuranceDeductPlanInformation',
      'generateQuickQuotationDocument',
    ]),
    onSearchPackageInformation() {
      this.validateForm()
    },
    onTriggerPackagePlanChange: _.debounce(function() {
      const { isCheckOPD, isCheckHIB, isCheckCancer, isCheckCI, opdType } = this.insurancePlan

      const IPD = 'IPD+PA'
      const OPD = isCheckOPD ? opdType : ''
      const HIB = isCheckHIB ? packagePlanType.HIB : ''
      const CANCER = isCheckCancer ? packagePlanType.CANCER : ''
      const CI = isCheckCI ? packagePlanType.CI : ''

      const packagePlanArr = [IPD, OPD, HIB, CANCER, CI]
      const filteredNoValue = _.filter(packagePlanArr, val => {
        const isValueEmpty = _.isEmpty(val)
        const isValueNull = _.isNull(val)

        return !(isValueEmpty || isValueNull)
      })

      const coverageCodes = _.join(filteredNoValue, '+')

      this.getInsurancePlanInformation({ coverageCodes, age: this.age })
    }, 200),
    validateForm() {
      this.validator
        .validateAll({
          age: this.age <= 0 || this.age > 70 ? null : this.age,
        })
        .then(result => {
          if (result) {
            this.getInsurancePlanInformation({ age: this.age })
            this.getInsuranceDeductPlanInformation(this.age)
          }
        })
    },
    clearErrors() {
      this.errors.clear()
    },
    setRule() {
      this.validator = new Validator(this.rules)
      this.$set(this, 'errors', this.validator.errors)
    },
    generateQuotationDocument() {
      const { planType, deductible } = this.insurancePlan

      if (!planType) {
        return this.$swal({
          type: 'error',
          title: 'กรุณาเลือกแผนประกัน',
        })
      }

      if (!deductible) {
        return this.$swal({
          type: 'error',
          title: 'กรุณาเลือกส่วนลด',
        })
      }

      const packagePlanList = _.get(this.insurancePlanInformationData, 'coveragePlanInfo.plans', [])
      const packageSchemeId = _.find(packagePlanList, plan => plan.planId === planType).schemeId

      const data = {
        age: this.age,
        packageSchemeId: packageSchemeId,
        deductId: deductible,
      }

      this.generateQuickQuotationDocument(data)
    },
  },
  created() {
    this.setRule()
  },
}
</script>

<style lang="scss">
.quick-quotation-container {
  margin-bottom: 50px;

  .quick-quotation-content {
    .age-input-panel-container {
      margin-bottom: 32px;

      .age-error-text {
        margin-left: 45px;
      }
    }

    .insurance-package-plan-information-section {
      .insurance-table-plan-container {
        margin-bottom: 24px;
      }
      .print-quotation-btn-container {
        text-align: right;
      }
    }
  }
}
</style>
